<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="شكر-وتقدير" style="padding-top:150px">
<p><span dir="rtl">كتابٌ سُيناقُض نفسه بين كُل صفحة وأُخرى سيكون هُناك جدال، تماماً كما يحدُث في عقلي.</span></p>
<br/>
<p style="text-align:center; direction:ltr">A book will contradict itself between every page there’s a dispute just like what’s going on my head.</p>
<br/>
<p><span dir="rtl">كُن ودوداً مع الظلام، لا حاجة لكونك صديقاً، فقط تجنب كونه عدواً لك</span></p>
<p><span dir="rtl">فأنت لا تريد أن تكونَ تعيساً.</span></p>
<br/>
<p style="text-align:center; direction:ltr">Be kind with the darkness no need to be its friend, but Avoid to be its enemy, you don’t want to be miserable.</p>
<br/>
<br/><p style="text-align:center">******</p><br/>
<br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?99ac55fc